module.exports = "/assets/data/70ff1d231c14f7420ac30a6217554885-NR6.data.json";